import { InputGroup, Form } from "react-bootstrap";

import { MeterFieldProps } from "../../../types/salesDocuments.types";
import { useMeterContext } from "../meterContext";
import { consumptionRates } from "../salesDocuments.constants";

import { ConsumptionRateField } from "./consumptionField";

export const ConsumptionComponent: React.FC<MeterFieldProps> = ({ meter, hidden }) => {
  const ctx = useMeterContext();

  if (hidden) return null;
  return (
    <div className="sales-doc-field mb-3">
      <hr className="sales-doc-divider" />

      {/* Loop over each consumption rate to dynamically generate form elements */}
      {consumptionRates.map((field) => (
        <ConsumptionRateField key={field.id} field={field} meter={meter} />
      ))}

      <div className="mb-3">
        <label htmlFor={`meter-${meter.id.toString()}-estimated-annual-cost`}>
          Estimated {ctx.consumptionMeasurement === "AQ" ? "Annual" : "Contractual"} Cost
        </label>
        <InputGroup>
          <InputGroup.Text>£</InputGroup.Text>
          <Form.Control
            type="number"
            min="0"
            step="0.00001"
            className="form-control"
            id={`meter-${meter.id.toString()}-estimated-annual-cost`}
            value={ctx.estimatedAnnualCost}
            onChange={(e) => {
              ctx.handleEstimatedAnnualCostChange(e.target.value);
            }}
            required
          />
        </InputGroup>
      </div>

      <div className="mb-3 form-check form-switch">
        <input
          type="checkbox"
          className="form-check-input"
          id={`manual-calculation-${meter.id.toString()}`}
          checked={ctx.manualCalculation}
          onChange={(e) => {
            ctx.setManualCalculation(e.target.checked);
          }}
        />
        <label className="form-check-label" htmlFor={`manual-calculation-${meter.id.toString()}`}>
          Manual Calculation
        </label>
      </div>

      <hr className="sales-doc-divider" />
      <div className="mb-3">
        <span
          id={`consumption-measurement-label-${meter.id.toString()}`}
          className="sales-doc-group-label"
        >
          Consumption Measurement
        </span>
        <div
          className="sales-doc-radios form-check"
          role="radiogroup"
          aria-labelledby={`consumption-measurement-label-${meter.id.toString()}`}
        >
          <label>
            <input
              type="radio"
              name={`consumption-measurement-${meter.id.toString()}`}
              className="form-check-input"
              value="annual"
              checked={ctx.consumptionMeasurement === "AQ"}
              onChange={() => {
                ctx.setConsumptionMeasurement("AQ");
              }}
            />
            <span>Annual</span>
          </label>
          <label>
            <input
              type="radio"
              className="form-check-input"
              name={`consumption-measurement-${meter.id.toString()}`}
              value="contractual"
              checked={ctx.consumptionMeasurement === "contractual"}
              onChange={() => {
                ctx.setConsumptionMeasurement("contractual");
              }}
            />
            <span>Contractual</span>
          </label>
        </div>
      </div>
      {ctx.kva && (
        <>
          <div className="sales-doc-field mb-2 read-only-field">
            <label htmlFor={`meter-${meter.id.toString()}-kva-charge`}>KVA Charge</label>
            <input
              id={`meter-${meter.id.toString()}-kva-charge`}
              type="text"
              className="form-control"
              value={ctx.kva.kvaCharge}
              readOnly
            />
          </div>
          <div className="sales-doc-field mb-2 read-only-field">
            <label htmlFor={`meter-${meter.id.toString()}-kva-capacity`}>KVA Capacity</label>
            <input
              id={`meter-${meter.id.toString()}-kva-capacity`}
              type="text"
              className="form-control"
              value={ctx.kva.kvaCapacity}
              readOnly
            />
          </div>
          <div className="sales-doc-field mb-3 read-only-field">
            <label htmlFor={`meter-${meter.id.toString()}-kva-charge-frequency`}>
              KVA Charge Frequency
            </label>
            <input
              id={`meter-${meter.id.toString()}-kva-charge-frequency`}
              type="text"
              className="form-control"
              value={ctx.kva.kvaChargeFrequency}
              readOnly
            />
          </div>
        </>
      )}
      <div className="mb-3">
        <span id={`includes-kva-label-${meter.id.toString()}`} className="sales-doc-group-label">
          Estimate includes kVA?
        </span>
        <div
          className="sales-doc-radios form-check"
          role="radiogroup"
          aria-labelledby={`includes-kva-label-${meter.id.toString()}`}
        >
          <label>
            <input
              type="radio"
              name={`includes-kva-${meter.id.toString()}`}
              className="form-check-input"
              value="yes"
              checked={ctx.includesKva === "na"}
              onChange={() => {
                ctx.setIncludesKva("na");
              }}
            />
            <span>N/A</span>
          </label>
          <label>
            <input
              type="radio"
              name={`includes-kva-${meter.id.toString()}`}
              className="form-check-input"
              value="yes"
              checked={ctx.includesKva === "yes"}
              onChange={() => {
                ctx.setIncludesKva("yes");
              }}
            />
            <span>Yes</span>
          </label>
          <label>
            <input
              type="radio"
              name={`includes-kva-${meter.id.toString()}`}
              className="form-check-input"
              value="no"
              checked={ctx.includesKva === "no"}
              onChange={() => {
                ctx.setIncludesKva("no");
              }}
            />
            <span>No</span>
          </label>
        </div>
      </div>
    </div>
  );
};
